<template>
  <UDropdownMenu
    :items="menuItems"
    :content="{ align: 'end', side: 'bottom' }"
  >
    <UUser
      :name="collapsed ? undefined : (admin?.name || admin?.phone || 'مدیر')"
      :description="collapsed ? undefined : roleLabel"
      :avatar="avatarProps"
      size="sm"
      class="cursor-pointer"
      :ui="{
        root: collapsed ? 'justify-center' : 'w-full',
      }"
    />
  </UDropdownMenu>
</template>

<script setup lang="ts">
import { ADMIN_ROLE_LABELS } from '~/types/admin'

const props = withDefaults(defineProps<{
  collapsed?: boolean
  settingsTo?: string
}>(), {
  settingsTo: '/admin/settings',
})

const adminStore = useAdminStore()
const admin = computed(() => adminStore.admin)
const roleLabel = computed(() => ADMIN_ROLE_LABELS[admin.value?.role ?? 'admin'] ?? 'مدیر')

const avatarProps = computed(() => ({
  alt: admin.value?.name || 'مدیر',
  icon: admin.value?.role === 'support' ? 'i-lucide-headset' : 'i-lucide-shield',
}))

const menuItems = computed(() => [
  [
    {
      label: 'تنظیمات حساب',
      icon: 'i-lucide-settings',
      to: props.settingsTo,
    },
  ],
  [
    {
      label: 'خروج از حساب',
      icon: 'i-lucide-log-out',
      color: 'error' as const,
      onSelect: async () => {
        await adminStore.logout()
        await navigateTo('/auth/login')
      },
    },
  ],
])
</script>
